// products
export const PRODUCT_DEFAULT_LIMIT = 250;
// variant statuses
export const VARIANT_STATUSES = {
  ACTIVE: "ACTIVE",
  PENDING: "PENDING",
  EXPIRED: "EXPIRED",
  NO_STOCK: "NO_STOCK",
  IN_STOCK: "IN_STOCK",
  DISABLED: "DISABLED",
};

export const NO_SET = "NO_SET";
export const ALL = "all";
